(function() {
'use strict';
  
  angular
    .module('app.shell')
    .config(statesConfig);
    
    statesConfig.$inject = ['$stateProvider'];
    
    function statesConfig($stateProvider) {
      $stateProvider
        .state('shell', {
          templateUrl: 'app/shell/shell.html',
          controller: 'ShellController as vm'
        })
        .state('shell.forbidden', {
          templateUrl: 'app/shell/shell.forbidden.html',
          // 'controller': 'ShellForbiddenController as vm'
        })
        .state('shell.missingState', {
          templateUrl: 'app/shell/shell.missing-state.html',
          controller: 'ShellMissingStateController as vm',
          params: {
            fromState: null,
            fromParams: null,
            toState: null,
            toParams: null,
            settings: null
          }
        });
        
    }
  
})(); 